import { fireEvent } from '../index';
import Modules from '../modules';
import { DATABASE_SEARCH_EVENTS as EVENTS } from './events';

type Tabs = 'ACCOUNTS' | 'CONTACTS';

// Common Events
export const trackDatabaseSearchTabs = (tab: string, data: any) => {
  const currentTab = tab === 'accounts' ? 'ACCOUNTS' : 'CONTACTS';
  fireEvent(EVENTS[currentTab].BASE, {
    ...data,
    moduleName:
      currentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
  });
};

export const trackDatabaseSearchChildTabs = (
  parentTab: Tabs,
  tab: 'TOTAL' | 'NET_NEW' | 'SAVED',
  data: any,
) => {
  tab === 'TOTAL'
    ? fireEvent(EVENTS[parentTab].TABS.TOTAL, {
        ...data,
        moduleName:
          parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
      })
    : tab === 'NET_NEW'
    ? fireEvent(EVENTS[parentTab].TABS.NET_NEW, {
        ...data,
        moduleName:
          parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
      })
    : fireEvent(EVENTS[parentTab].TABS.MOVED_TO_TAL, {
        ...data,
        moduleName:
          parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
      });
};

export const trackDatabaseSearchSideBarOptions = (tab: 'filters' | 'saved', data: any) => {
  fireEvent(EVENTS[tab === 'saved' ? 'SAVED' : 'FILTERS'], data);
};

export const trackDatabaseSearchEditView = (parentTab: Tabs, data: any) => {
  fireEvent(EVENTS[parentTab].EDIT_VIEW, {
    ...data,
    moduleName:
      parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
  });
};

export const trackDatabaseSearchSaveToTAL = (parentTab: Tabs, data: any) => {
  fireEvent(EVENTS[parentTab].SAVE_TO_TAL, {
    ...data,
    moduleName:
      parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
  });
};

export const trackDatabaseSearchSaveToTALModal = (
  parentTab: Tabs,
  type: 'save' | 'cancel',
  data: any,
) => {
  if (type === 'save') {
    fireEvent(EVENTS[parentTab].SAVE_TO_TAL_CONFIRM, {
      ...data,
      moduleName:
        parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
    });
  } else if (type === 'cancel') {
    fireEvent(EVENTS[parentTab].SAVE_TO_TAL_CANCEL, {
      ...data,
      moduleName:
        parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
    });
  }
};

export const trackDatabaseSearchSaveToTALSkipContacts = (data: any) => {
  fireEvent(EVENTS.ACCOUNTS.SAVE_TO_TAL_SKIP_CONTACTS, {
    ...data,
    moduleName: Modules['Database Accounts'],
  });
};

export const trackDatabaseSearchAddToList = (type: 'default' | 'confirm' | 'cancel', data: any) => {
  if (type === 'confirm') {
    fireEvent(EVENTS.CONTACTS.ADD_TO_LIST_CONFIRM, {
      ...data,
      moduleName: Modules['Database Contacts'],
    });
  } else if (type === 'cancel') {
    fireEvent(EVENTS.CONTACTS.ADD_TO_LIST_CANCEL, {
      ...data,
      moduleName: Modules['Database Contacts'],
    });
  } else {
    fireEvent(EVENTS.CONTACTS.ADD_TO_LIST, { ...data, moduleName: Modules['Database Contacts'] });
  }
};

export const trackDatabaseSearchCreditsUsage = (data: any) =>
  fireEvent(EVENTS.CONTACTS.CREDITS_USAGE, { ...data, moduleName: Modules['Database Contacts'] });

export const trackDatabaseSearchContact = (data: any) =>
  fireEvent(EVENTS.CONTACTS.SEARCH_CONTACT, { ...data, moduleName: Modules['Database Contacts'] });

export const trackDatabaseSearchActionsAddToList = (data: any) =>
  fireEvent(EVENTS.CONTACTS.ACTIONS.ADD_TO_LIST, {
    ...data,
    moduleName: Modules['Database Contacts'],
  });

export const trackDatabaseSearchActionsMoveToTarget = (data: any) =>
  fireEvent(EVENTS.CONTACTS.ACTIONS.MOVE_TO_TARGET, {
    ...data,
    moduleName: Modules['Database Contacts'],
  });

export const trackDatabaseSearchSidebarTabs = (parentTab: Tabs, filterTab: string, data: any) => {
  const tab = filterTab === 'saved' ? 'SAVED' : 'FILTERS';
  fireEvent(EVENTS[parentTab].LISTING_FILTERED[tab], {
    ...data,
    moduleName:
      parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
  });
};

export const trackDatabaseSearchFilterClear = (parentTab: string, data: any) => {
  const currentTab = parentTab === 'accounts' ? 'ACCOUNTS' : 'CONTACTS';
  fireEvent(EVENTS[currentTab].CLEAR_FILTER, {
    ...data,
    moduleName:
      parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
  });
};

export const trackDatabaseSearchFilterSaveSearch = (parentTab: string, data: any) => {
  const currentTab = parentTab === 'accounts' ? 'ACCOUNTS' : 'CONTACTS';
  fireEvent(EVENTS[currentTab].SAVE_SEARCH, {
    ...data,
    moduleName:
      parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
  });
};

export const trackDatabaseSearchClearSelection = (parentTab: Tabs, data: any) => {
  fireEvent(EVENTS[parentTab].CLEAR_SELECTION, {
    ...data,
    moduleName:
      parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
  });
};

export const trackDatabaseSearchClearIndividual = (parentTab: string, data: any) => {
  const currentTab = parentTab === 'accounts' ? 'ACCOUNTS' : 'CONTACTS';
  fireEvent(EVENTS[currentTab].CLEAR_INDIVIDUAL_FILTER, {
    ...data,
    moduleName:
      parentTab === 'ACCOUNTS' ? Modules['Database Accounts'] : Modules['Database Contacts'],
  });
};

export const trackDatabaseSearchClearAll = (data: any) => fireEvent(EVENTS.CLEAR_ALL, data);

export const trackDatabaseSearch3RecentSearches = () => {};
export const trackDatabaseSearch3LatestSaved = () => {};

// ? ACCOUNT DETAILS EVENTS:

export const trackSideDrawerClick = (clientName: string) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.SIDE_DRAWER_CLICK, { tenant_name: clientName });
export const trackSideDrawerDomainClick = (clientName: string) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.SIDE_DRAWER_DOMAIN_CLICK, { tenant_name: clientName });
export const trackSideDrawerLinkedInClick = (clientName: string) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.SIDE_DRAWER_LINKEDIN_CLICK, {
    tenant_name: clientName,
  });
export const trackADAddToListClick = (clientName: string) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.AD_ADD_TO_LIST, { tenant_name: clientName });
export const trackADSaveToList = (clientName: string, list_names: string[]) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.AD_SAVE_TO_LIST, {
    tenant_name: clientName,
    'List Names': list_names,
  });

export const trackADQualifyClick = (clientName: string) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.AD_QUALIFY, {
    tenant_name: clientName,
  });
export const trackADSkipAndQualifyClick = (
  clientName: string,
  enrich_email: boolean,
  enrich_phone: boolean,
) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.AD_QUALIFY, {
    tenant_name: clientName,
    'Enrich Email': enrich_email,
    'Enrich Phone': enrich_phone,
  });
export const trackADQualifyAndProceedClick = (
  clientName: string,
  enrich_email: boolean,
  enrich_phone: boolean,
) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.AD_QUALIFY_AND_PROCEED, {
    tenant_name: clientName,
    'Enrich Email': enrich_email,
    'Enrich Phone': enrich_phone,
  });
export const trackADQualifyCancelClick = (clientName: string) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.AD_QUALIFY_CANCEL, {
    tenant_name: clientName,
  });
export const trackADSeeMoreDesc = (clientName: string) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.AD_SEE_MORE_DESC, {
    tenant_name: clientName,
  });
export const trackADSeeMoreCompanyKeys = (clientName: string) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.AD_SEE_MORE_COMPANY_KEYS, {
    tenant_name: clientName,
  });
export const trackADSeeMoreJobOpenings = (clientName: string) =>
  fireEvent(EVENTS.ACCOUNTS.ACCOUNT_DETAILS.AD_SEE_MORE_JOB_OPENINGS, {
    tenant_name: clientName,
  });

// ? CONTACT DETAILS EVENTS:

export const trackContactDetailsSidebarOpen = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_NAME_TABLE_ACTION, data);
};
export const trackContactDetailsSidebarLinkedin = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_LINKEDIN_ACTION, data);
};
export const trackContactDetailsSidebarCompanyLink = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_COMPANY_NAME_ACTION, data);
};
export const trackContactDetailsSidebarAddToList = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_ADD_TO_LIST_ACTION, data);
};
export const trackContactDetailsSidebarAddToListSave = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_ADD_TO_LIST_SAVE_ACTION, data);
};
export const trackContactDetailsQualify = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_QUALIFY_ACTION, data);
};
export const trackContactDetailsQualifyProceed = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_QUALIFY_YES_ACTION, data);
};
export const trackContactDetailsContactOverview = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_OVERVIEW_ACTION, data);
};
export const trackContactDetailsEmployeeHistory = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_VIEW_ALL_EMPLOYEES_ACTION, data);
};
export const trackContactDetailsEducationHistory = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_VIEW_ALL_EDUCATION_ACTION, data);
};
export const trackContactDetailsAccountWebsite = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_ACCOUNT_DOMAIN_ACTION, data);
};
export const trackContactDetailsAccountLinkedin = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_ACCOUNT_LINKEDIN_ACTION, data);
};
export const trackContactDetailsRevealContactInfo = (data: any) => {
  fireEvent(EVENTS.CONTACTS.DETAILS_SIDEBAR.CONTACT_SIDEBAR_REVEAL_CONTACT_INFO_ACTION, data);
};
